module.exports = __webpack_public_path__ + "static/media/slide3.a89c8d0c.jpg";